import type { Provider } from '@openfeature/web-sdk';
import { Event } from '@zajno/common/observing/event';
import { createDatadogProvider } from './datadog';
import { SystemFlagsClientEngine } from './engine';
import type { CreateSystemFlagsClientOptions, ISystemFlagsClient } from './types';

export function createSystemFlagsClient(options: CreateSystemFlagsClientOptions): ISystemFlagsClient {
  const lateAnswer = new Event<void>();
  const provider = createDatadogProvider(options.datadog, {
    timeoutMs: options.timeoutMs,
    onLateAnswer: () => lateAnswer.trigger(),
  });

  const engine = createEngine(provider, options);
  lateAnswer.on(() => engine.resendContext());
  return engine;
}

/** Builds the client engine directly from an explicit OpenFeature provider — the test seam for this package. */
export function createSystemFlagsClientFromProvider(
  provider: Provider | undefined,
  options: Omit<CreateSystemFlagsClientOptions, 'datadog'>,
): ISystemFlagsClient {
  return createEngine(provider, options);
}

function createEngine(provider: Provider | undefined, options: Omit<CreateSystemFlagsClientOptions, 'datadog'>): SystemFlagsClientEngine {
  return new SystemFlagsClientEngine(
    provider,
    options.targetingKeyStore,
    options.timeoutMs,
  );
}
